"use strict";

import $ from "jquery";
import "leaflet";
import "./leaflet-data-markers.min";
import enquire from "enquire.js";
import "jquery.scrollto";

export default class Map {
  constructor() {
    /**
    1) INITIALIZE MAP
    2) MOBILE DEFINITIONS AND EVENTS
    3) EVENTS
    4) HELPER FUNCTIONS
    **/

    /** 1) INITIALIZE MAP **/
    let $mapContainer = $("#map"),
      x = $mapContainer.data("x"),
      y = $mapContainer.data("y"),
      mapBounds = [
        // south, west
        [1.3250758, 103.7156471],
        // north, east
        // [1.3468187, 103.7359337]
        [1.3472593, 103.7373621],
      ],
      imageBounds = [
        [1.3249912, 103.7119177],
        [1.347291, 103.7373959],
      ],
      getPinsEndpoint = $mapContainer.data("endpoint"),
      defaultCategory = $mapContainer.data("defaultCategory"),
      getMapImagePath = $mapContainer.data("image"),
      markers;

    window.markersArray = [];

    $(document).ready(function () {
      let guid = getUrlParameter("guid"),
        category = getUrlParameter("category");

      openPopupFromQuery(guid, category);
    });

    let center = [x, y];
    let map = L.map("map").setView(center, 17);

    let basemap = L.tileLayer(
      "https://maps-{s}.onemap.sg/v3/Grey/{z}/{x}/{y}.png",
      {
        zoomControl: false,
        detectRetina: true,
        maxZoom: 19,
        minZoom: 17,
      }
    );

    map.on("drag", function () {
      map.panInsideBounds(mapBounds, { animate: false });
    });

    /** HANDLE POSITION OF ZOOM CONTROLS **/
    L.control
      .zoom({
        position: "topright",
      })
      .addTo(map);

    /** SETBOUNDS **/
    map.setMaxBounds(mapBounds);

    basemap.addTo(map);

    map.scrollWheelZoom.disable();

    let imageUrl = getMapImagePath;

    L.imageOverlay(imageUrl, imageBounds).addTo(map);

    /** 2) MOBILE DEFINITIONS AND EVENTS **/
    enquire.register("screen and (max-width:1080px)", {
      // OPTIONAL
      // If supplied, triggered when a media query matches.
      match: function () {
        let $mapFilter = $(".map__filter"),
          $mapEach = $(".map__each"),
          $mapListItem = $(".map__item");

        $('.map__filter[data-show="filter"]').addClass("active");
        $mapEach.removeClass("hide-mobile");

        $('.map__each[data-filter="list"]').addClass("hide-mobile");

        $mapFilter.click(function (e) {
          e.preventDefault();

          let category = $(this).data("show");
          let categoryItem = $(this)
            .parent(".map__filters")
            .siblings(".map__categories")
            .find(".map__category.active")
            .data("category");

          $mapFilter.removeClass("active");
          $(this).addClass("active");

          $mapEach.addClass("hide-mobile");
          $(`.map__each[data-filter="${category}"]`).removeClass("hide-mobile");
          $(`.map__list[data-category="${categoryItem}"]`).addClass("show");
        });

        // hide filter list after click
        $mapListItem.on("click", function () {
          let $this = $(this);
          $this.parents(".map__lists").removeClass("hide-mobile");
          $(".map__list").removeClass("show");
          $this.parents(".map__lists").addClass("hide-mobile");
        });

        // to close map filters on mobile if clicked outside
        $(document).mouseup(function (e) {
          var container = $mapEach;

          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.addClass("hide-mobile");
          }
        });
      },
    });

    /** 3) EVENTS **/
    $("body").on("click", ".leaflet-marker-icon", function () {
      let guid = $(this).data("guid"),
        mapItemOfInterest = $(`.map__item[data-guid="${guid}"]`),
        activeMapList = $(".map__list.show");

      $mapItem.removeClass("active");
      mapItemOfInterest.addClass("active");

      activeMapList.scrollTo(mapItemOfInterest, 300);
    });

    let $mapCategory = $(".map__category"),
      $mapList = $(".map__list");

    $mapCategory.click(function (e) {
      e.preventDefault();

      showAllMarkers();

      $(".leaflet-pane.leaflet-popup-pane").empty();

      let category = $(this).data("category");

      getPins(category, getPinsEndpoint);

      $mapCategory.removeClass("active");
      $(this).addClass("active");

      $mapList.removeClass("show");
      $(`.map__list[data-category="${category}"]`).addClass("show");
    });

    let $mapItem = $(".map__item");

    $mapItem.click(function (e) {
      e.preventDefault();

      $mapItem.removeClass("active");
      $(this).addClass("active");

      let guid = $(this).data("guid"),
        category = $(this).data("category");

      findMarker(guid, category);

      showAllMarkers();
      hideMarker(guid);
    });

    /** HELPER FUNCTIONS **/

    function centerOnMarker(latLng) {
      map.setView(latLng, 15);
    }

    function findMarker(guid, category) {
      for (let i in window.markersArray) {
        if (window.markersArray[i].marker._icon.dataset.guid == guid) {
          let latLng = window.markersArray[i].marker.dragging._marker._latlng,
            popupHtml = window.markersArray[i].html;

          callPopup(popupHtml, category, latLng);

          showAllMarkers();
          hideMarker(guid);
          $(".map__item").removeClass("active");
          $(`.map__item[data-guid="${guid}"]`).addClass("active");

          $mapList.removeClass("show");
          $(`.map__list[data-category="${category}"]`).addClass("show");
        }
      }
    }

    function showAllMarkers() {
      $(".leaflet-marker-icon").css("opacity", "1");
    }

    function hideMarker(guid) {
      $(`.leaflet-marker-icon[data-guid="${guid}"]`).css("opacity", "0");
    }

    var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split("&"),
        sParameterName,
        i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split("=");

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined
            ? true
            : decodeURIComponent(sParameterName[1]);
        }
      }
    };

    function openPopupFromQuery(guid, category) {
      if (guid && category) {
        // remove active from class from all
        // add active class to the correct one
        showActiveMenu(category);

        getPins(category, getPinsEndpoint);

        // open popup here
        // findMarker(guid, category);

        setTimeout(function () {
          findMarker(guid, category);
        }, 500);
      } else {
        getPins(defaultCategory, getPinsEndpoint);
      }
    }

    function showActiveMenu(category) {
      $(".map__category").removeClass("active"); // remove from all

      $(`.map__category[data-category="${category}"]`).addClass("active"); //set category button to active

      $(`.map__list`).removeClass("show"); //remove all map__list

      $(`.map__list[data-category="${category}"]`).addClass("show");
    }

    function getPins(category, endpoint) {
      $.ajax({
        type: "GET",
        url: endpoint,
        data: {
          category: category,
        },
        dataType: "json",
        success: function (data) {
          renderPins(data, map);
        },
        error: function (error) {
          console.log(error);
        },
      });
    }

    function renderPins(array, map) {
      let allMarkers = [];
      window.markersArray = [];

      if (markers) {
        markers.clearLayers();
      }

      array.forEach(function (each, idx) {
        if (each.Id) {
          let coordinates = [each.X, each.Y],
            id = each.Id,
            guid = each.Guid,
            category = each.Color,
            desc = each.Desc,
            thumbnail = each.Thumbnail,
            title = each.Title,
            url = each.Url;

          let urlHtml = "";
          let urlHtmlMobile = "";

          if (url.length > 1) {
            urlHtml = `<a href="${url}">View More</a>`;
            urlHtmlMobile = `<a href="${url}" class="popup__link"><span class="icon icon-arrow-right"></span></a>`;
          }

          let popupHtml = `
          <div class="popup">
          <span class="popup__marker">${id}</span>
          <h3>${title}</h3>
          <div class="popup__thumbnail">
          <img class="object-fit" src="${thumbnail}"/>
          </div>
          <div class="popup__content">
          <p class="popup__desc">${desc}</p>
          ${urlHtml}
          </div>
          ${urlHtmlMobile}

          </div>`;

          let myIcon = L.dataDivIcon({
            className: `marker__${category} marker`,
            iconSize: 40,
            data: {
              guid: guid,
            },
            html: `<span class="marker__id">${id}</span>`,
          });

          let marker = L.marker(coordinates, { icon: myIcon });

          let markerObj = {
            marker: marker,
            html: popupHtml,
          };

          marker.on("click", function (e) {
            let guid = e.sourceTarget._icon.dataset.guid;

            callPopup(popupHtml, category, e.latlng);

            showAllMarkers();
            hideMarker(guid);
          });

          allMarkers.push(marker);

          window.markersArray.push(markerObj);
        }
        markers = L.layerGroup(allMarkers).addTo(map);
      });
    }

    function callPopup(html, category, latLng) {
      // 1) center map on marker
      centerOnMarker(latLng);
      // 2) initialise popup
      let popup = L.popup({
        className: category,
        closeButton: true,
        maxWidth: 250,
        closeOnClick: false,
        keepInView: true,
      })
        .setLatLng(latLng)
        .setContent(html)
        .openOn(map);

      map.panTo(latLng);

      // 3) on clicking X button to close, show all markers
      popup.on("remove", function () {
        showAllMarkers();
      });

      //centerOnMarker(latLng);
    }
  }
}
